module.exports = __webpack_public_path__ + "img/skull_process.43b4cbc0.png";